export enum SOCKET_LOCATION_EVENT {
  /**
   * Recieves an event when a location is added
   */
  added = 'location:added',
  /**
   * Recieves an event when a location is removed
   */
  removed = 'location:removed',
  /**
   * Recieves an event when a location has modified his drawers
   */
  drawers_modified = 'location:drawers_modified',
  /**
   * Recieves an event when a location is activated
   */
  activated = 'location:activated',
}
